import { WritableSignal, signal } from '@angular/core';
import { IData } from '@core/models/IApi';

export const DATA_STATUS = {
    INIT: 'INIT',
    STALE: 'STALE',
    OK: 'OK',
} as const;

export type DataStatus = (typeof DATA_STATUS)[keyof typeof DATA_STATUS];

export class BaseState<T = IData, K = T> {
    data = signal<T[]>([]);
    dataStatus = signal<DataStatus>(DATA_STATUS.INIT);
    isLoading = signal(false);
    errorMsg = signal('');
}

// Make selected optional . Can't have an optional prop in the base class
export interface BaseState<T = IData, K = T> {
    selected?: WritableSignal<K | K[] | undefined>;
}

// if no K is declared, defaults to T . Set in case 'selected' need it's own typing
export class SingleSelectState<T = IData, K = T> extends BaseState<T, K> {
    override selected = signal<K | undefined>(undefined);
}

export class MultiSelectState<T = IData, K = T> extends BaseState<T, K> {
    override selected = signal<K[]>([]);
}
